import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { FormatNumber, glb_sv } from 'src/utils';
import { useTranslation } from 'react-i18next';
import Label from 'src/components/label';

const STATUS_COLOR = {
    0: 'secondary',
    1: 'success',
    2: 'warning',
    3: 'info',
    4: 'error',
    5: 'success',
};

const ItemRow = ({ child, item }) => {
    const { t } = useTranslation();
    return (
        <Stack direction="row" alignItems="center" spacing={2} sx={{ p: 1, borderBottom: '1px solid #eee' }}>
            <img
                src={
                    child.img_device
                        ? glb_sv.urlGetProductImage(child.img_device)
                        : glb_sv.urlGetProductImage(child.pic_device)
                }
                alt={child.device_nm}
                style={{
                    width: 40,
                    height: 40,
                    borderRadius: 4,
                    objectFit: 'cover',
                }}
            />
            <Stack flex={1} spacing={0.5}>
                <Typography variant="subtitle2" noWrap>
                    {child.device_nm}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                    {`${child.cabinet_nm} / ${child.drawer_nm} / Ô [${child.cell_lc.row},${child.cell_lc.column}]`}
                </Typography>
            </Stack>
   

            <Stack alignItems="flex-end" spacing={0.5}>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                    <Typography variant="caption" color={child.bussiness === 'etk' ? 'primary.main' : 'secondary.main'}>
                        {child.bussiness_nm}
                    </Typography>
                    <Label color={STATUS_COLOR[child.status]}>{child.status_nm}</Label>{' '}
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                    <Typography variant="body2" fontWeight={600}>
                        {FormatNumber(child.price_request_device)}
                    </Typography>

                    <Typography variant="body2" fontWeight={600}>
                        x{child.qty}
                    </Typography>
                </Box>
            </Stack>
        </Stack>
    );
};

export default ItemRow;
